import { render, staticRenderFns } from "./EditSingleOwner.vue?vue&type=template&id=09104772&scoped=true&lang=html&"
import script from "./EditSingleOwner.vue?vue&type=script&lang=js&"
export * from "./EditSingleOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09104772",
  null
  
)

export default component.exports